import { RoomTypes } from '../types';

const roomReducer = (state = -1, action: RoomTypes) => {
    switch (action.type) {
        case 'SET_ROOM':
            state = action.roomCode;
            return state;
        default:
            return state;
    }
};

export default roomReducer;
